import { c as _c } from "react/compiler-runtime";
import { IconNowBubble, MyMenuFix, MyMenuFixOn } from '@module/svg/icons';
import { DropdownMenuItem } from '@pc/components/ui/dropdown-menu';
import { useContext } from 'react';
import { AllMenuContainer } from './AllMenuContainer';
import MenuContext from './MenuContext';
import { menuSvg } from './menuSvg';
export function MyMenu() {
  const $ = _c(15);
  const {
    navigateHandler,
    selectList,
    addItemHandler,
    isAdult,
    userInfo,
    initMyListHandler
  } = useContext(MenuContext);
  let t0;
  if ($[0] !== addItemHandler || $[1] !== initMyListHandler || $[2] !== isAdult || $[3] !== navigateHandler || $[4] !== selectList || $[5] !== userInfo?.vipSignatureInfo?.highlight) {
    let t1;
    if ($[7] !== addItemHandler || $[8] !== isAdult || $[9] !== navigateHandler || $[10] !== selectList || $[11] !== userInfo?.vipSignatureInfo?.highlight) {
      t1 = (el, i) => {
        const active = selectList.some(s => s.title === el.title);
        return <div className="item" key={i}><DropdownMenuItem className="px-1.5 text-box" onClick={() => navigateHandler(el)}><div className="w-5 ">{menuSvg[el.img]}</div><div>{el.title}</div></DropdownMenuItem>{userInfo?.vipSignatureInfo?.highlight === "Y" && el.url === "/my/signatureUser" && <IconNowBubble />}{isAdult && <div className="favorites-icon" onClick={e => addItemHandler(e, el)}>{active ? <MyMenuFixOn /> : <MyMenuFix />}</div>}</div>;
      };
      $[7] = addItemHandler;
      $[8] = isAdult;
      $[9] = navigateHandler;
      $[10] = selectList;
      $[11] = userInfo?.vipSignatureInfo?.highlight;
      $[12] = t1;
    } else {
      t1 = $[12];
    }
    t0 = initMyListHandler("my").map(t1);
    $[0] = addItemHandler;
    $[1] = initMyListHandler;
    $[2] = isAdult;
    $[3] = navigateHandler;
    $[4] = selectList;
    $[5] = userInfo?.vipSignatureInfo?.highlight;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[13] !== t0) {
    t1 = <AllMenuContainer title={"MY \uBA54\uB274"} isbottom={true}><>{t0}</></AllMenuContainer>;
    $[13] = t0;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  return t1;
}